import { createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "form-icon"
}, null, -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode();

var _hoisted_3 = {
  class: "c-hand"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("label", {
    class: {
      'form-checkbox': _ctx.type === 'box',
      'form-switch': _ctx.type === 'switch'
    }
  }, [_createVNode("input", {
    type: "checkbox",
    id: _ctx.id,
    disabled: _ctx.disabled,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('update:modelValue', $event.target.checked);
    }),
    checked: _ctx.modelValue
  }, null, 8, ["id", "disabled", "checked"]), _hoisted_1, _hoisted_2, _createVNode("span", _hoisted_3, [_renderSlot(_ctx.$slots, "default")])], 2);
}